import { Checkout } from '../types/checkout';
import { MoedaVendaDescricao } from '../types/enums/moeda-venda.enum';
import { buildFbc, buildFbp } from './facebook-utils';
import { getUrlParams } from './get-url-params';
import { gerarTokenRecaptcha } from './getReCaptcha';
import { CreatePurchaseContract } from '../types/create-purchase-contract';
import { Api } from '../hooks/useApi';

export const emitFacebookEvent = async (input: {
  event: string;
  eventId?: string;
  checkout: Checkout;
  data?: CreatePurchaseContract;
}) => {
  const api = new Api();
  try {
    const { event, eventId, checkout, data } = input;
    const recaptchaToken = await gerarTokenRecaptcha('/produto/facebook_pixel/id');
    const response = await api.Produto.emitEvent(checkout?.id, {
      eventName: event,
      eventId: eventId ?? undefined,
      recaptchaToken,
      parametros: {
        event_source_url: `https://checkout.vendepay.com/${checkout?.id}`,
        customData: {
          value: checkout?.valor,
          currency: MoedaVendaDescricao[checkout?.moeda],
        },
        user_data: {
          //Dados pessoais
          em: [data?.email],
          ph: [data?.phoneNumber],
          fn: [data?.fullName?.split(' ')?.[0]],
          ln: [data?.fullName?.split(' ')?.slice(1).join(' ')],
          db: undefined,
          ge: undefined,
          //FBP e FBC
          fbp: buildFbp(),
          fbc: buildFbc(),
          //Geolocation
          ct: data?.city ? [data?.city] : undefined,
          st: data?.state ? [data?.state] : undefined,
          zp: data?.postalCode ? [data?.postalCode] : undefined,
          country: checkout?.pais ? [checkout?.pais] : undefined,
          //ExternalId
          external_id: [checkout?.externalId],
        },
        custom_data: {
          value: checkout?.valor,
          currency: MoedaVendaDescricao[checkout?.moeda],
        },
        utm_source: getUrlParams('utm_source'),
        utm_medium: getUrlParams('utm_medium'),
        utm_campaign: getUrlParams('utm_campaign'),
        utm_content: getUrlParams('utm_content'),
        utm_term: getUrlParams('utm_term'),
      },
    });
    return response.data;
  } catch (e) {
    console.error('Erro no tracking do Facebook:', e);
  }
};
